var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isDisplayed)?_c('iw-input-checkbox',{staticClass:"field",attrs:{"input-label":_vm.$t('cable_tv'),"name":"has-cable-tv"},model:{value:(_vm.hasCableTv),callback:function ($$v) {_vm.hasCableTv=$$v},expression:"hasCableTv"}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }